import { getAccessToken, getProfile, getRefreshToken, isSupportTab, removeProfile, setAccessToken, setRefreshToken } from '@/utils/tokenStore';
import Swal from "sweetalert2";
import i18n from "@/i18n/index";
import enums from "./enums";
import dayjs from "dayjs";
import "dayjs/locale/ko";

const { YnEnum } = enums();

export function jwtDecoder(jwtCode) {
  resetWrongTokens();
  // 지원 탭이면 넘어온 값 대신 그 탭의 지원 토큰을 읽는다. 호출은 모두 「지금 로그인 토큰」을 넘기는데,
  // 보존 검사(check:contracts-v5-preserve)로 고칠 수 없는 v3 계약 화면 5곳이 localStorage 를 직접 넘기기 때문.
  if (isSupportTab()) jwtCode = getAccessToken();
  if (jwtCode) {
    const base64Url = jwtCode.split(".")[1];
    // Base64URL to Base64 conversion (JWT uses Base64URL encoding)
    let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    while (base64.length % 4) {
      base64 += "=";
    }
    const companyId = JSON.parse(atob(base64))["sub"];
    return companyId;
  } else {
    return "";
  }
}

export function resetWrongTokens() {
  const accessToken = getAccessToken();
  const refreshToken = getRefreshToken();
  if (accessToken === "null" || accessToken === "undefined") {
    setAccessToken(null);
  }
  if (refreshToken === "null" || refreshToken === "undefined") {
    setRefreshToken(null);
  }
}

export function changeBytesToMegabytes(bytes) {
  return bytes / 1024 / 1024;
}

export const formatCommaNumber = (value) => {
  if (value) return value.toLocaleString("en-US");
  else return value;
};

export const twoBtnHtmlDialog = async (title, htmlText, confirmBtnText) => {
  const response = await Swal.fire({
    title: title,
    html: htmlText,
    buttonsStyling: false,
    confirmButtonText: confirmBtnText ? confirmBtnText : "확인",
    cancelButtonText: "취소",
    showCancelButton: true,
    heightAuto: true,
    customClass: {
      confirmButton: "btn btn-primary-confirm btn-hover swal-button-custom",
      cancelButton: "btn btn-secondary-cancel btn-hover swal-button-custom",
    },
    reverseButtons: true,
  });
  if (response) {
    const isConfirmed = response.isConfirmed;
    return isConfirmed;
  } else {
    return false;
  }
};

// dialog 열기
export async function oneBtnDialog(title, text, needsRefresh) {
  await Swal.fire({
    title: title,
    text: text,
    buttonsStyling: false,
    confirmButtonText:
      getProfile("locale") === "zh" ? "确认" : "확인",
    heightAuto: true,
    allowOutsideClick: false,
    customClass: {
      confirmButton: "btn btn-primary btn-hover",
    },
  }).then(() => {
    if (needsRefresh) {
      setTimeout(() => {
        location.reload();
      }, 80);
    }
  });
}
// 다섯째 인자: 예전 호출은 reverseButtons(불리언), 객체면 admin-hospital 과 같은 options.
// options.confirmStyle === "danger": 되돌릴 수 없는 동작이면 확인을 흰 면·빨간 글자로, 취소(안전한 쪽)를 노란 면으로.
// 이 앱은 .swal2-actions 가 row-reverse 라, danger 는 뒤집지 않아야 confirmDialog 처럼 「취소」 왼쪽·동작 오른쪽.
// options.focusCancel: 창이 뜰 때 포커스를 「취소」에(Enter 한 번에 되돌릴 수 없는 동작이 실행되지 않게)
export async function twoBtnDialog(
  title,
  text,
  confirmBtnText,
  cancelBtnText,
  reverseButtons
) {
  const options =
    reverseButtons && typeof reverseButtons === "object" ? reverseButtons : {};
  const danger = options.confirmStyle === "danger";
  if (typeof reverseButtons !== "boolean") reverseButtons = undefined;
  const response = await Swal.fire({
    title: title,
    text: text,
    buttonsStyling: false,
    confirmButtonText: confirmBtnText ? confirmBtnText : "확인",
    cancelButtonText: cancelBtnText
      ? cancelBtnText
      : getProfile("locale") === "zh"
      ? "取消"
      : "취소",
    showCancelButton: true,
    heightAuto: true,
    customClass: {
      confirmButton: danger
        ? "btn btn-danger-confirm btn-hover swal-button-custom"
        : "btn btn-primary-confirm btn-hover swal-button-custom",
      cancelButton: danger
        ? "btn btn-primary-confirm btn-hover swal-button-custom"
        : "btn btn-secondary-cancel btn-hover swal-button-custom",
    },
    reverseButtons: reverseButtons !== undefined ? reverseButtons : !danger,
    focusCancel: !!options.focusCancel,
  });
  if (response) {
    const isConfirmed = response.isConfirmed;
    return isConfirmed;
  } else {
    return false;
  }
}

export const oneBtnHtmlDialog = async (
  title,
  vueComponentElement,
  needsRefresh
) => {
  await Swal.fire({
    title: title,
    html: vueComponentElement,
    buttonsStyling: false,
    showCancelButton: false,
    heightAuto: true,
    confirmButtonText: "확인",
    customClass: {
      confirmButton: "btn btn-primary",
    },
    reverseButtons: true,
  }).then(() => {
    if (needsRefresh) location.reload();
  });
};

//삭제 dialog
export async function confirmDialog(title, text) {
  const response = await Swal.fire({
    title: title,
    text: text,
    buttonsStyling: false,
    confirmButtonText: "확인",
    cancelButtonText: "취소",
    showCancelButton: true,
    heightAuto: true,
    customClass: {
      confirmButton: "btn btn-primary-confirm btn-hover",
      cancelButton: "btn btn-secondary-cancel btn-hover",
    },
  });
  if (response) {
    const isConfirmed = response.isConfirmed;
    return isConfirmed;
  } else {
    return false;
  }
}
// 날짜만 보여주기(스트링 잘라서)
export function convertDate(dateString) {
  if (dateString) {
    return dateString.split("T")[0].replaceAll("-", "/");
  } else {
    return `-`;
  }
}

// 날짜와 시간 보여주기(스트링 잘라서)
export function convertDateTime(dateString) {
  if (dateString) {
    const date = dateString.split("T")[0].replaceAll("-", "/");
    const time = dateString.split("T")[1].split(".")[0];
    return `${date} ${time}`;
  } else {
    return `-`;
  }
}

export function phoneNumberFormatter(phoneNumber) {
  if (!phoneNumber) return "";
  else {
    const value = phoneNumber.replace(/[^0-9]/g, "");

    // Check if the length is 12 for special formatting
    if (value.length === 12) {
      return value.replace(/([0-9]{4})([0-9]{4})([0-9]{4})/, "$1-$2-$3");
    }

    // Existing formatting for other cases
    return value.replace(
      /(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,
      "$1-$2-$3"
    );
  }
}

export function businessNumberFormatter(businessNumber) {
  if (!businessNumber) return "";
  const value = businessNumber.replace(/[^0-9]/g, "");

  if (value.length <= 3) {
    return value;
  } else if (value.length <= 5) {
    return value.replace(/(\d{3})(\d{0,2})/, "$1-$2");
  } else {
    return value.replace(/(\d{3})(\d{2})(\d{0,5})/, "$1-$2-$3");
  }
}

export function decodeUtfText(text) {
  const byteArray = Uint8Array.from(text, (c) => c.charCodeAt(0));
  const decoder = new TextDecoder("utf-8");
  const decodedText = decoder.decode(byteArray);
  return decodedText;
}

export function splitNumberUntilZero(number) {
  let result = number;

  while (result % 10 === 0 && result !== 0) {
    result = Math.floor(result / 10);
  }

  return result;
}

export const dateUtils = () => {
  return {
    unixTimeToYYYYMMDD(unixTime) {
      return dayjs(unixTime).format("YYYYMMDD");
    },
    YYYYMMDDtoUnixTime(dateString) {
      return dayjs(dateString, "YYYYMMDD").valueOf();
    },
  };
};
export const logging = () => {
  return {
    exceptProd: (txt, obj) => {
      if (process.env.NODE_ENV !== "production") {
        console.log(txt, obj);
      }
    },
  };
};

export const deepCopy = (obj) => {
  if (!obj) return;
  return JSON.parse(JSON.stringify(obj));
};

export const convertYnToBool = (ynEnum) => {
  if (ynEnum === YnEnum.Y) return true;
  if (ynEnum === YnEnum.N) return false;
  return ynEnum;
};

export const boolToYn = (bool) => {
  if (bool === true) return YnEnum.Y;
  if (bool === false) return YnEnum.N;
  return bool;
};

export const getPrivilegeInfoByName = (
  categoryArray,
  categoryName,
  menuName
) => {
  const obj = {
    create: false,
    read: false,
    update: false,
    delete: false,
  };
  if (!Array.isArray(categoryArray)) return obj;
  const category = categoryArray.find(
    (category) => category.name === categoryName
  );
  if (!category.menu || !Array.isArray(category.menu)) return obj;
  const menu = category
    ? category.menu.find((menu) => menu.menuName === menuName)
    : null;
  if (!menu) return obj;
  if (menu.read && (menu.read === "M" || menu.read === YnEnum.Y)) {
    obj.read = true;
  }
  if (menu.write && menu.write === YnEnum.Y) {
    obj.create = true;
  }
  if (menu.update && menu.update === YnEnum.Y) {
    obj.update = true;
  }
  if (menu.delete && menu.delete === YnEnum.Y) {
    obj.delete = true;
  }

  return obj;
};

export const getValueByTraitType = (attributes, targetValue) => {
  let value = "";
  if (attributes) {
    for (const item of attributes) {
      if (item.trait_type === targetValue) {
        value = item.value;
      }
    }
  }
  return value;
};
export const convertMonthAndYearText = (input) => {
  if (!input) return "";
  if (input < 12) return `${input}개월`;
  return `${input / 12}년`;
};

// 로컬 시간으로 변환 (ISO 8601 형식 변환)
export const convertToLocalTime = (dateString) => {
  if (!dateString) return "-";

  try {
    const date = new Date(dateString);

    // 날짜가 유효한지 확인
    if (isNaN(date.getTime())) {
      return "-";
    }

    // 로컬 시간 형식으로 변환 YYYY/MM/DD HH:mm:ss
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
  } catch (error) {
    console.error("Date conversion error:", error);
    return "-";
  }
};

/**
 * 로그아웃.
 *
 * 원래 Sidenav/index.vue 안에만 있던 것을 옮겼다. 마이페이지에서도 로그아웃해야 하는데,
 * 두 벌로 복사하면 한쪽만 고쳐지는 사고가 난다 — 확인 팝업·로케일 제거·앱 브리지 통지·
 * 중국어 도메인 분기까지 단계가 여러 개다.
 *
 * 컴포넌트가 아니라서 $i18n·$store·$router 를 넘겨받는다.
 * @param {{ i18n: object, store: object, router: object }} ctx
 */
export async function signOut({ i18n, store, router }) {
  const confirmResult = await twoBtnDialog(
    i18n.t('navbar_signout'),
    i18n.t('navbar_signout_confirm'),
    i18n.t('common_confirm')
  );
  if (!confirmResult) return false;

  if (isSupportTab()) {
    await store.dispatch('endSupport');
    return true;
  }
  removeProfile('locale');
  await store.dispatch('clearLocalStorage');
  window.checkIsLoggedIn({
    isLoggedIn: false,
    accessToken: null,
    refreshToken: null,
  });
  document.querySelector('body').classList.remove('modal-open');

  if (i18n.locale == 'zh') {
    // 중국 제조사 어드민은 admin-china-manufacturer로 이관됨
    window.location.href = 'https://manufacturer.xinlaian.cn/';
    return true;
  }
  router.push('/signin');
  return true;
}

/**
 * 지금 폰 폭인가.
 *
 * 768px 은 App.vue 의 isMobileView, router/index.js 의 isMobile 과 같은 값이다.
 * 세 곳이 각자 갖고 있는데, 여기까지 합치면 diff 가 넓어져 그대로 둔다.
 * 값을 바꿀 일이 생기면 세 곳을 함께 봐야 한다.
 */
export function isMobileWidth() {
  return window.innerWidth < 768;
}

/**
 * 폰에서 로그인 직후 도착할 화면.
 *
 * 마이페이지가 항상 탭에 있으므로 탭이 하나도 없는 경우는 없다.
 * 그래서 대시보드가 아니라 첫 탭으로 보낸다.
 *
 * PC 에서는 반드시 null 을 준다. 그래야 호출한 쪽이 기존 목적지(routingPath)로
 * 가고, 운영과 동작이 같아진다.
 *
 * 폭을 여기서도 보는 이유:
 * getVisibleMobileTabs 는 마이페이지를 항상 붙이므로 빈 배열이 될 수 없다.
 * 즉 '탭이 없으면 PC' 라는 구분이 성립하지 않는다. 폭을 보지 않으면
 * PC 에서도 탭 경로가 나와 로그인 후 대시보드가 아닌 곳으로 가게 된다.
 *
 * @returns {string|null} 첫 탭의 link, PC 이거나 탭이 없으면 null
 */
export function getMobileLandingPath(store) {
  if (!isMobileWidth()) return null;
  const tabs = store?.getters?.getVisibleMobileTabs || [];
  return tabs.length ? tabs[0].link : null;
}


/**
 * 카테고리를 보지 않고 메뉴명만으로 권한을 찾는다.
 *
 * getPrivilegeInfoByName 은 카테고리명까지 맞아야 권한을 돌려주는데,
 * 카테고리명은 운영 페이지에서 자유 입력으로 언제든 바뀌는 값이다.
 * 실제로 「기타 → 정품 인증」으로 옮기자 버튼이 전부 사라졌다 (2026-07-30).
 *
 * 서버(assertMenuFlag)도 menuName 만 보고 판정하므로 이쪽이 서버와 기준이 같다.
 * 카테고리를 옮겨도 화면과 서버의 판정이 어긋나지 않는다.
 *
 * ⚠️ 새로 붙이는 화면은 아래 getPrivilegeInfoByMenuLink 를 쓴다.
 *    메뉴명도 운영 페이지에서 바뀌는 값이라 판정 기준으로는 link 가 안전하다.
 */
export const getPrivilegeInfoByMenuName = (categoryArray, menuName) => {
  const obj = {
    create: false,
    read: false,
    update: false,
    delete: false,
  };
  if (!Array.isArray(categoryArray)) return obj;
  const menu = categoryArray
    .flatMap((category) => (Array.isArray(category?.menu) ? category.menu : []))
    .find((item) => item.menuName === menuName);
  if (!menu) return obj;
  if (menu.read && (menu.read === "M" || menu.read === YnEnum.Y)) {
    obj.read = true;
  }
  if (menu.write && menu.write === YnEnum.Y) {
    obj.create = true;
  }
  if (menu.update && menu.update === YnEnum.Y) {
    obj.update = true;
  }
  if (menu.delete && menu.delete === YnEnum.Y) {
    obj.delete = true;
  }

  return obj;
};

/**
 * 메뉴 link 로 권한을 찾는다. 정품 인증 화면들이 쓰는 기준이다.
 *
 * 메뉴명으로 찾던 것을 link 로 옮긴 이유:
 *   menuName 은 운영 페이지에서 언제든 바뀌는 값인데, 바뀌면 이 조회가 조용히
 *   빗나가 버튼만 사라진다. 게다가 서버는 privilege 문서에 **복사되어 저장된**
 *   menuName 을 보는데 그 복사본은 메뉴명을 바꿔도 갱신되지 않아서, 화면과 서버의
 *   판정이 서로 다른 이름을 보는 상태가 된다.
 *
 *   link 는 라우트 경로라 이름과 달리 마음대로 바뀌지 않고, 바꾸려면 어차피 코드
 *   수정이 따른다. privilege 문서에도 menuName 과 나란히 저장돼 있어 서버도 같은
 *   값을 볼 수 있다. menuId 는 환경마다 달라서 못 쓴다.
 *
 * link 는 메뉴 등록 화면의 「링크명」 값과 정확히 같아야 한다.
 * 예: 정품 라벨 등록은 /product-label 이 아니라 /product-label/list 다.
 */
export const getPrivilegeInfoByMenuLink = (categoryArray, menuLink) => {
  const obj = {
    create: false,
    read: false,
    update: false,
    delete: false,
  };
  if (!Array.isArray(categoryArray)) return obj;
  const menu = categoryArray
    .flatMap((category) => (Array.isArray(category?.menu) ? category.menu : []))
    .find((item) => item.link === menuLink);
  if (!menu) return obj;
  if (menu.read && (menu.read === "M" || menu.read === YnEnum.Y)) {
    obj.read = true;
  }
  if (menu.write && menu.write === YnEnum.Y) {
    obj.create = true;
  }
  if (menu.update && menu.update === YnEnum.Y) {
    obj.update = true;
  }
  if (menu.delete && menu.delete === YnEnum.Y) {
    obj.delete = true;
  }

  return obj;
};
